import { Shield, Star, Eye, Heart } from 'lucide-react';
import { siteConfig } from '@/config/site';
import { useLanguage } from '@/context/LanguageContext';
import VixenCarousel from './VixenCarousel';

export function AboutSection() {
  const { language } = useLanguage();
  const content = siteConfig.content[language].about;

  const icons = [Shield, Star, Eye, Heart];

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#0B0A12]" data-testid="about-section">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <p className="text-[#FF4DA6] text-sm font-semibold uppercase tracking-widest mb-2">
              {content.subtitle}
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#F4F2FF] mb-6">
              {content.title}
            </h2>
            <p className="text-[#A7A3BA] text-lg leading-relaxed mb-8">
              {content.description}
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {content.features.map((feature, idx) => {
                const Icon = icons[idx % icons.length];
                return (
                  <div
                    key={idx}
                    className="flex items-center gap-3 p-4 rounded-xl bg-[#111022] border border-white/5"
                    data-testid={`about-feature-${idx}`}
                  >
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#FF4DA6]/20 to-[#8B5CFF]/20 flex items-center justify-center">
                      <Icon className="w-5 h-5 text-[#FF4DA6]" />
                    </div>
                    <span className="text-[#F4F2FF] text-sm font-medium">{feature}</span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Interactive 3D coverflow showcase */}
          <div className="relative">
            <VixenCarousel />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
